import { _env, _l10n } from '../stores.js';

// A little messy with all the _, sorry.
let l10n_, env_;

_l10n.subscribe((value) => {
  l10n_ = value;
});

_env.subscribe((value) => {
  env_ = value;
});

// Do we need to unsubscribe aswell?

const l10nOrPlaceholder = (key) => {
  return l10n_[key] == undefined ? `[${key}]` : l10n_[key];
};

const l10nOrEmpty = (key) => {
  return l10n_[key] == undefined ? '' : l10n_[key];
};

export const l10n = (key) => {
  if (env_ === 'prod') {
    return l10nOrEmpty(key);
  } else {
    // If 'local' or 'test' show placeholder
    return l10nOrPlaceholder(key);
  }
};

export const getAcceptLanguage = (languageIso, countryIso) => {
  if (typeof countryIso === 'string' && countryIso.length === 2) {
    return `${languageIso}-${countryIso}`;
  }

  return languageIso;
};
